export default __webpack_public_path__ + "static/media/Ballroll_00383.e365cd9b.png";